module.exports = __webpack_public_path__ + "static/minesense-logo-e87b076ff19219ab2a740b2c2ee8408a.png";